import React from 'react';
import ApplicationByStatus from './applicationsByStatus/ApplicationByStatus';
import OpenApplicationTypes from './openApplicationTypes/OpenApplicationTypes';
import ApplicationsByPerson from './applicationsByPerson/ApplicationsByPerson';
import BusinessTypes from './businessTypes/BusinessTypes';
import TimeSummary from './timeSummary/TimeSummary';
import FlaggedCertifications from './flaggedCertifications/FlaggedCertifications';
import { Box, ActionButton } from 'fw/components'
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Col, Row } from "react-bootstrap";
import * as App from 'modules/app/App'

class AdminDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
		};
	}

	handlePrint = () => {
		window.print();
	}

	render() {

		return (
			App.hasPrivilege("AdminDashboardAccess") ?
				<React.Fragment>
					<section className="content-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<h1>Dashboard – <small>Manage VOB's within VOCS</small></h1>
						<ActionButton
							id="btnPrintDashboard"
							onClick={this.handlePrint}
							icon="print"
							bsSize="sm"
							style={{ display: 'inline-block', width: 'auto' }}
						>
							Print
						</ActionButton>
					</section>
					<ContentBody>
						<Box>
							<Row>
								<Col md={8}>
									<Row>
										<Col md={12}>
											<ApplicationByStatus>
											</ApplicationByStatus>
										</Col>
									</Row>
									<Row>
										<Col md={12}>
											<OpenApplicationTypes>
											</OpenApplicationTypes>
										</Col>
									</Row>
									<Row>
										<Col md={12}>
											<ApplicationsByPerson>
											</ApplicationsByPerson>
										</Col>
									</Row>
								</Col>
								<Col md={4}>
									<BusinessTypes>
									</BusinessTypes>
									<Row style={{ marginTop: '15px' }}>
										<Col md={6}>
											<TimeSummary
												title="Monthly Summary"
												endpoint="/dashboard/getMonthlySummary"
												className="monthly-summary-grid"
											/>
										</Col>
										<Col md={6}>
											<TimeSummary
												title="YTD Summary"
												endpoint="/dashboard/getYTDSummary"
												className="ytd-summary-grid"
											/>
										</Col>
									</Row>
								</Col>
							</Row>
							<Row className="no-print">
								<ContentHeader title={"Flagged Applications – "} description={"Please review all flagged items"}>
								</ContentHeader>
								<ContentBody>
									<FlaggedCertifications>
									</FlaggedCertifications>
								</ContentBody>
							</Row>
						</Box>
					</ContentBody>
				</React.Fragment >
				: null
		)
	}
}

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDashboard/AdminDashboard.js